var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MMenu',{class:{'tabs__tab_active': _vm.isActive},attrs:{"items":_vm.localItems,"popper-class":_vm.popperClass,"placement":"bottom-start","popper-options":{
    modifiers: {
      preventOverflow: {
        boundariesElement: 'viewport',
        priority: ['right', 'left', 'top', 'bottom'],
        padding: 16
      },
      flip: {
        enabled: false
      },
      offset: {
        offset: '0, -2'
      }
    }
  }},on:{"item-click":_vm.handleMenuClick},model:{value:(_vm.menuOpen),callback:function ($$v) {_vm.menuOpen=$$v},expression:"menuOpen"}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }